// eslint-disable-next-line import/no-cycle
import APP_ERROR_CODES from '@/assets/data/errorCodes';
import router from '@/router/index';
import { useErrorStore } from '@/stores/components/errorStore';
import { logError } from '@/composables/tracking/useGoogleAnalyticTracking';
import usePartnerIframePostMessage from '@/composables/iframe/usePartnerIframePostMessage';

export default () => {
  const { notifyError } = usePartnerIframePostMessage();

  function storeErrorInStore(errorCode, errorMessage, traceId) {
    const errorStore = useErrorStore();
    errorStore.setError({
      code: errorCode,
      message: errorMessage,
      traceId,
    });
  }

  function getTraceIdFromHeaders(headers) {
    const traceIdKey = Object.keys(headers).find((key) => key.toLowerCase() === 'x-tts-trace-id');
    return traceIdKey ? headers[traceIdKey] : null;
  }

  function handleServerErrors(error) {
    const isNetworkError = !error?.response;
    const defaultErrorCode = isNetworkError ? 'NETWORK_ERROR' : 'UNKNOWN_ERROR';
    const defaultErrorMsg = isNetworkError
      ? 'We could not reach our servers. Check your connection and try again.'
      : 'An unexpected error occurred';
    const responseStatus = error?.response?.status;
    const responseData = error?.response?.data;
    const headers = error?.response?.headers || {};
    const errorCode = responseData?.code || responseStatus || defaultErrorCode;
    const errorMsg = responseData?.message
      || error?.response?.statusText
      || error?.message
      || defaultErrorMsg;
    const traceId = getTraceIdFromHeaders(headers);

    logError({
      type: 'API', errorCode, errorMsg, traceId,
    });

    storeErrorInStore(errorCode, errorMsg, traceId);
    notifyError(errorCode, errorMsg);

    if (router.currentRoute.value?.name === 'error') {
      return;
    }

    router.push({
      name: 'error',
      params: { errorCode: String(errorCode) },
    });
  }

  function handleMappedErrorResponses(code) {
    const { field, error, callback } = APP_ERROR_CODES.get(code) || {};
    if (callback) {
      callback();
    }

    return field || error ? { field, error } : null;
  }

  function handleErrorInSpaFlow(errorCode, message, traceId) {
    storeErrorInStore(errorCode, message, traceId);
    notifyError(errorCode, message);

    logError({
      type: 'APP', code: errorCode, message, traceId,
    });

    router.push({
      name: 'error',
      params: {
        errorCode: String(errorCode),
      },
    });
  }

  return {
    handleServerErrors,
    handleMappedErrorResponses,
    handleErrorInSpaFlow,
    getTraceIdFromHeaders,
  };
};
